<section class="d-flex flex-grow-1 h-auto shadow-nx rounded-gt-md-7 p-12 w-fit-content">
    <div class="container-fluid align-self-center">
        <span class="gt-greytip-header-logo mb-12 block m-auto" *ngIf="!disableGreytHrLogo"></span>
        <router-outlet></router-outlet>
    </div>
</section>
